import httpClient from '../httpService';
import { PLAN_GiaoVien } from './GiaoVienModels';

const GiaoVienApiUrl = '/api/giaovien/';

const unwrapArrayResponse = <T,>(response: any): T[] => {
    if (!response || response.is_success === false || response.data?.is_success === false)
        throw Error('Không tải được danh mục giảng viên.');
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data?.data)) return response.data.data;
    if (Array.isArray(response?.data)) return response.data;
    throw Error('Phản hồi danh mục giảng viên không hợp lệ.');
};

export const GiaoVienService = {
    getAll: async (): Promise<PLAN_GiaoVien[]> => {
        const res = await httpClient.get(GiaoVienApiUrl + 'getAll');
        return unwrapArrayResponse<PLAN_GiaoVien>(res);
    }
};
